import React from 'react';
import { Form, Table} from 'react-bootstrap';
import {Container} from "@mui/material";
import {FaInfoCircle} from "react-icons/all";
import {formatCurrency} from "../data.js"

const InstallmentsTable = (props) => {
    const handleRowClick = (item) => {
        props.setSelectedInstallmentId(item.moId)
    };

    return (
        <Container style={{marginRight: "5px", marginLeft: "5px"}}>
            <Table striped bordered hover className="custom-table" style={{textAlignLast: "center"}}>
                <thead>
                <tr>
                    <th></th>
                    <th>Vade</th>
                    <th>Taksit Tutarı</th>
                    <th>Banka Komisyon Oranı</th>
                    <th>Banka Komisyon Tutarı</th>
                    <th>Toplam Tutar</th>
                </tr>
                </thead>
                <tbody>
                {props.data.map((item, index) => (
                    <tr key={item} onClick={() => handleRowClick(item)}>
                        <td>
                            <Form.Check
                                type="radio"
                                name="selectedRow"
                                checked={props?.selectedInstallmentId === item.moId}
                                onChange={() => handleRowClick(item)}
                            />
                        </td>
                        <td>{item.vade}</td>
                        <td>{formatCurrency(item.taksitTutari)}</td>
                        <td>{item.bankaKomisyonOrani.toFixed(3)}</td>
                        <td>{formatCurrency(item.bankaKomisyonTutari)}</td>
                        <td>{formatCurrency(item.toplamTutari)}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <div style={{color: "#e80000", fontWeight: "bold", fontSize: "x-small"}}>
                <FaInfoCircle style={{color: 'orange', marginTop: '-2px'}}/>
                <span style={{color: 'black', fontStyle: 'italic'}}> Banka Komisyon Tutarı, faturanıza yansımayacak olup, bankanız tarafından tahsil edilmek üzere kredi kartınıza yansıyacaktır.</span>
            </div>
        </Container>
    );
};

export default InstallmentsTable;
